import { MonthPeriodPicker } from './MonthPeriodPicker'
import { YearPeriodPicker } from './YearPeriodPicker'
import { useWindRoseStore } from '../../../store/useWindRoseStore'

// Hlavička pro měsíční/roční větrnou růžici — analog GrafHeaderMin.jsx: period picker
// vlevo (s doménovými přepínači windrose v headerExtra) a formát/interaktivita grafu
// v ml-auto bloku vpravo, stejné umístění jako ChartFormatPicker u ostatních reportů.
export function WindRoseHeader({ stype, year, onYearChange, month, onMonthChange }) {
  const { vtype, setVtype, intervals, setIntervals, chartFormat, setChartFormat, interactive, setInteractive } = useWindRoseStore()

  const domainToggles = (
    <>
      <div className="flex flex-col gap-1">
        <span className="text-xs text-gray-400 font-medium uppercase tracking-wide whitespace-nowrap">Směry</span>
        <div className="flex items-center gap-3">
          {[['R08', '8 směrů'], ['R16', '16 směrů']].map(([val, label]) => (
            <label key={val} className="flex items-center gap-1 text-xs text-gray-600 cursor-pointer whitespace-nowrap">
              <input
                type="radio"
                name="wr-vtype"
                checked={vtype === val}
                onChange={() => setVtype(val)}
                className="accent-blue-600"
              />
              {label}
            </label>
          ))}
        </div>
      </div>

      <div className="flex flex-col gap-1">
        <span className="text-xs text-gray-400 font-medium uppercase tracking-wide whitespace-nowrap">Rychlost</span>
        <label className="flex items-center gap-1.5 text-xs text-gray-600 cursor-pointer whitespace-nowrap">
          <input
            type="checkbox"
            checked={intervals}
            onChange={e => setIntervals(e.target.checked)}
            className="accent-blue-600"
          />
          S intervaly rychlosti
        </label>
      </div>
    </>
  )

  return (
    <div className="flex flex-wrap items-start gap-4">
      {/* allowCurrent=false: růžice se počítá až nad kompletním měsícem/rokem */}
      {stype === 'MONTH'
        ? <MonthPeriodPicker year={year} month={month} onYearChange={onYearChange} onMonthChange={onMonthChange} obsType="DLY" headerExtra={domainToggles} allowCurrent={false} />
        : <YearPeriodPicker year={year} onYearChange={onYearChange} obsType="DLY" headerExtra={domainToggles} allowCurrent={false} />
      }

      <div className="flex flex-wrap items-start gap-4 ml-auto">
        <div className="flex flex-col gap-1">
          <span className="text-xs text-gray-400 font-medium uppercase tracking-wide">Formát</span>
          <div className="flex items-center gap-3">
            {['png', 'jpg', 'svg'].map(fmt => (
              <label key={fmt} className="flex items-center gap-1 text-xs text-gray-600 cursor-pointer">
                <input
                  type="radio"
                  name="wr-chartFormat"
                  checked={chartFormat === fmt}
                  onChange={() => setChartFormat(fmt)}
                  className="accent-blue-600"
                />
                {fmt.toUpperCase()}
              </label>
            ))}
            <label className="flex items-center gap-1.5 text-xs text-gray-600 cursor-pointer ml-2 border-l pl-3 border-gray-200">
              <input
                type="checkbox"
                checked={interactive}
                onChange={e => setInteractive(e.target.checked)}
                className="accent-blue-600"
              />
              Interaktivní
            </label>
          </div>
        </div>
      </div>
    </div>
  )
}
